var _path, _path2, _path3, _path4, _path5, _rect, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReportCsv(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#475467",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.667,
    d: "M17 29h-5.6c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748C5 25.96 5 24.506 5 22.266V8.4c0-2.24 0-3.36.436-4.216a4 4 0 0 1 1.748-1.748C8.04 2 9.16 2 11.4 2H19l8 8v9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF3600",
    fillOpacity: 0.5,
    d: "m20.429 13.024-3.17-1.816a2.545 2.545 0 0 0-2.518 0l-3.17 1.816a2.49 2.49 0 0 0-1.259 2.16v3.631a2.489 2.489 0 0 0 1.26 2.16l3.17 1.816a2.54 2.54 0 0 0 2.517 0l3.17-1.815a2.489 2.489 0 0 0 1.259-2.16v-3.632a2.489 2.489 0 0 0-.34-1.247 2.509 2.509 0 0 0-.92-.913Zm-.137 4.447-1.733 2.98c-.2.342-.502.614-.864.778-.363.164-.645.198-1.019.253-.563.081-1.05.114-1.384.03a1.928 1.928 0 0 1-.884-.498l-2.456-2.433a1.88 1.88 0 0 1-.547-1.13 1.87 1.87 0 0 1 .255-.95l1.734-2.98c.171-.295.42-.538.719-.704.299-.166.777-.231 1.35-.299.383-.045.742-.106 1.085-.05.343.057.755.25 1.037.53l2.453 2.43c.237.235.408.527.496.848.055.414-.03.835-.242 1.195Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF3600",
    fillOpacity: 0.5,
    d: "m17.11 14.375-2.86 2.115 1.848 1.008-.77 2.127 2.86-2.115-1.849-1.008.77-2.127Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#475467",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m20.667 26.667 4 4m0 0 4-4m-4 4v-8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#475467",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.667,
    d: "M19 3v5.507c0 .747 0 1.48.145 1.765.128.25.332.455.583.583.285.145.525.145 1.272.145h5"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 9,
    x: 2,
    y: 16,
    fill: "#16B364",
    rx: 1
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M3.62 19.02c.223-.448.53-.79.92-1.024.389-.235.834-.352 1.335-.352.475 0 .864.08 1.168.24.31.155.552.373.728.656.182.283.31.616.384 1l-.872.136c-.09-.395-.24-.704-.448-.928-.202-.224-.525-.336-.968-.336a1.47 1.47 0 0 0-.904.28c-.245.181-.432.44-.56.776-.128.33-.192.723-.192 1.176 0 .677.144 1.219.432 1.624.294.405.707.608 1.24.608.326 0 .587-.053.784-.16.198-.112.347-.264.448-.456.107-.197.179-.424.216-.68h.904c-.037.4-.15.755-.336 1.064-.186.31-.448.555-.784.736-.336.176-.752.264-1.248.264-.533 0-.994-.117-1.384-.352a2.302 2.302 0 0 1-.888-1.016c-.208-.448-.312-.987-.312-1.616 0-.645.112-1.192.336-1.64Zm5.301 2.816h.88c.059.373.208.645.448.816.24.17.595.256 1.064.256.31 0 .552-.043.728-.128a.794.794 0 0 0 .376-.344 1.01 1.01 0 0 0 .112-.472.937.937 0 0 0-.08-.392.649.649 0 0 0-.28-.312c-.139-.09-.341-.16-.608-.208l-.728-.128a4.084 4.084 0 0 1-.976-.288 1.438 1.438 0 0 1-.6-.52c-.139-.224-.208-.51-.208-.856 0-.357.093-.656.28-.896.187-.24.443-.419.768-.536a3.111 3.111 0 0 1 1.104-.184c.501 0 .899.072 1.192.216.299.139.523.323.672.552.15.23.248.48.296.752l-.84.136c-.08-.304-.213-.533-.4-.688-.181-.16-.485-.24-.912-.24-.475 0-.805.083-.992.248a.758.758 0 0 0-.28.6c0 .256.07.45.208.584.144.128.4.227.768.296l.792.152c.603.112 1.043.299 1.32.56.283.261.424.643.424 1.144 0 .32-.08.608-.24.864-.16.25-.4.45-.72.6-.315.15-.712.224-1.192.224-.688 0-1.243-.144-1.664-.432-.416-.288-.653-.747-.712-1.376Zm4.894-4.048h.984l1.624 4.656 1.656-4.656h.952L16.903 23.5h-.96l-2.128-5.712Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportCsv);
export default __webpack_public_path__ + "static/media/reportCsv.d6c00d1111d0dd7079b8c1cbdeeccf66.svg";
export { ForwardRef as ReactComponent };